import {
  AbstractControl,
  AsyncValidatorFn,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import {
  catchError,
  debounceTime,
  delay,
  distinctUntilChanged,
  map,
  Observable,
  of,
  Subject,
  switchMap,
} from 'rxjs';

export function phoneNumberValidator(dependent?: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dependentFormControl = dependent
      ? control.parent?.get(dependent)
      : null;
    if (dependentFormControl && !!dependentFormControl.value?.length) {
      console.log('validator', dependentFormControl.value);

      if (dependentFormControl.value[0].id === 0) {
        if (!/^\+1[2-9]\d{2}[2-9]\d{6}$/.test(control.value)) {
          return { invalid: 'invalid phone number' };
        }
      }
    }
    return null;
  };
}

/* Not used */
export function workEmailValidation(): AsyncValidatorFn {
  console.log('workEmailValidation');
  return (control: AbstractControl): Promise<ValidationErrors | null> => {
    return new Promise((s, r) => {
      setTimeout(() => {
        if (control.value === 'sk@gm.com') return s(null);
        control.markAsTouched();
        return s({
          invalid:
            'Please use a work email; personal emails (e.g., @gmail, @outlook) are not accepted.',
        });
      }, 0);
    });
  };
}
export const customEmailValidator = (checkWorkEmail: boolean = true)=>{
  return (
    control: AbstractControl
  ): { [key: string]: string } | null => {
      const email = control.value;
      // Replace the regular expression with the pattern you want to use.
      
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
      if (emailPattern.test(email)) {
        if(checkWorkEmail && !isWorkEmail(email)){
          return {
            invalid:
              'Please use a work email; personal emails (e.g., @gmail, @outlook) are not accepted.', // invalid email
          };
        }
        return null; // Valid email
      } else {
        return {
          invalid:
            'Email address is not valid',
        }; // Invalid email
      }
  };
}

const isWorkEmail = (email: string): boolean=>{
  const invalidEmailHosts: string[] = ['gmail', 'yahoo', 'hotmail','yopmail'];
  if(email){
    let [userName , domainName] = email.split('@');
    for(let i = 0 ; i < invalidEmailHosts.length ; i++){
      let re = new RegExp(`.*${invalidEmailHosts[i]}\..*`);
      if(re.test(domainName)){ 
        return false;
      }
    }
    return true;
  }
  return false;
}

export function samePasswordValidator(dependent: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dependentFormControl = dependent
      ? control.parent?.get(dependent)
      : null;
    if (dependentFormControl && !!dependentFormControl.value?.length) {
      if (control.value && dependentFormControl.value !== control.value) {
        if (!control.touched) {
          control.markAsTouched();
        }
        return { invalid: 'Password mismatch' };
      }
    }
    return null;
  };
}

export function noWhitespaceValidator(control: FormControl) {
  return (control.value || '').trim().length? null : { invalid: 'Please enter valid data' };       
}
